import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'src/ui/library/styled';
import { DateFormatInput } from 'material-ui-next-pickers';
import SvgIcon from '@material-ui/core/SvgIcon';
import InputAdornment from '@material-ui/core/InputAdornment';

const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexWrap: 'wrap',
    height: 48,
    margin: '0',
  },
  textFieldFocus: {},
  inputRoot: {
    width: 150,
    margin: 'auto',
    padding: '0px 7px',
  },
  formLabel: {
    color: theme.colors.eyConfidentGrey,
    paddingLeft: '8px',
  },
  formControl: {
    transform: 'translate(0, 16px) scale(1)',
  },
  shrink: {
    transform: 'translate(0, 8px) scale(0.75)',
    marginBottom: '8px',
    color: theme.colors.eyGrey1,
  },
  showPassword: {
    fontFamily: 'caption',
  },
  dateIcon: {
    //top: '7px',
    height: '100%',
    right: '7px',
    position: 'absolute',
  },
});

const DateInputBase = props => {
  const {
    classes,
    id,
    name,
    onChange,
    okToConfirm = false,
    className,
    disableUnderline,
    hasError,
    value,
    InputLabelProps,
    ...otherProps
  } = props;
  return (
    <DateFormatInput
      id={id}
      name={name}
      value={value || null}
      className={classNames(classes.root, className)}
      onChange={date => onChange(date, name)}
      anchorOrigin={{ top: 'bottom' }}
      dateFormat="dd-MMM-yyyy"
      okToConfirm={okToConfirm}
      InputProps={{
        disableUnderline,
        className: classes.inputRoot,
        endAdornment: (
          <InputAdornment position="end" classes={{ root: classes.dateIcon }}>
            <SvgIcon>
              <path
                fill="#747480"
                d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1"
              />
            </SvgIcon>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: !!value,
        classes: {
          formControl: classes.formControl,
          shrink: classes.shrink,
        },
        FormLabelClasses: {
          root: classes.formLabel,
          focused: classes.focused,
        },
        ...InputLabelProps,
      }}
      {...otherProps}
    />
  );
};

DateInputBase.propTypes = {
  /** Classname to be applied to <TextField> */
  className: PropTypes.string,
  /** If `true`, the input will not have an underline. */
  disableUnderline: PropTypes.bool,
  /** If `true`, textfield will be in error state */
  hasError: PropTypes.bool,
  /** Override or extend default styles */
  styles: PropTypes.object,
  /** Name attribute of the `input` element. */
  name: PropTypes.string.isRequired,
  /** Value of `input` element */
  value: PropTypes.any,
  /** Text used for input label */
  label: PropTypes.string,
  /** If `true`, the label is displayed as required. */
  required: PropTypes.any,
  /** Callback fired when value is changed */
  onChange: PropTypes.func,
};

export default styled(DateInputBase)(styles);
